<div class="mainCard">
    <img
        class="maintenance-logo"
        src="./assets/img/maintenance-mode.svg"
        alt="Blue logo with laptop and symbols to note site is under maintenance"
    />
    <h1 class="heading">SITE MAINTENANCE</h1>
    <p class="text">This site is undergoing some routine maintenance. Please check back again soon.</p>
    <!-- <p class="text">The site is expected to be back by {{ expectedTimeBack | date:'short' }}.</p> -->
</div>
